import Translations from "./translations";

export default Translations;


